<template>
  <div id="app">
    <Loader />
    <div class="navbar-wrapper">
      <Navbar />
    </div>
    <div
      class="content-wrapper"
      :class="{'wrapper-offset': menuVisibleWhileMobile}"
    >
      <router-view />
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import Loader from '@/views/Loader.vue'

export default {
  name: 'Main',
  components: {
    Navbar,
    Footer,
    Loader
  },
  computed: {
    ...mapGetters([
      'menuVisibleWhileMobile'
    ])
  }
}
</script>

<style lang="scss">
html {
  font-size: 19px;
}
#app {
  // font-family: Avenir, Helvetica, Arial, sans-serif;
  // -webkit-font-smoothing: antialiased;
  // -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  // font-size: 14px;
  font-family: "Courier New", Courier, "Lucida Sans Typewriter",
    "Lucida Typewriter", monospace;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
  .b-toast-success .toast,
  .b-toast-danger .toast,
  .b-toast-warning .toast,
  .b-toast-info .toast {
    font-size: 1.5rem;
    background-color: white;
  }
}
.content-wrapper {
  width: 100%;

  position: relative;
  height: auto;
  min-height: 100%;
  transition-duration: 0.5s;
}
.wrapper-offset {
  transform: translateX(75vw);
}
.content-wrapper-small {
  width: 100%;

  position: relative;
  height: auto;
  min-height: 100%;
}
@media (min-width: 992px) {
  #app {
    min-height: 100vh;
    width: 100%;
  }
  .navbar-wrapper {
    width: 25%;
    float: left;
    height: 100vh;
  }
  .content-wrapper {
    width: 75%;
    min-height: 100vh;
    float: left;
  }
}
</style>
